// extracted by mini-css-extract-plugin
export default {"container":"InvoiceDetail_container__lwqdE","viewContent":"InvoiceDetail_viewContent__WrW+c"};